module.exports = __webpack_public_path__ + "img/BK-alfa2.8441c0fb.png";